module.exports = __webpack_public_path__ + "img/summit-4.7c753ac0.jpg";